var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLangArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.848 11.6432C8.45633 12.2699 7.54367 12.2699 7.152 11.6432L3.95625 6.53C3.53997 5.86395 4.01881 5 4.80425 5L11.1958 5C11.9812 5 12.46 5.86395 12.0438 6.53L8.848 11.6432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLangArrow);
export default __webpack_public_path__ + "static/media/ic-lang-arrow.8c3ec0ec2f87bfcc33fb81091432a107.svg";
export { ForwardRef as ReactComponent };